import { http } from "../api/http";
import Utils from "../utils";

// #2642/#2643: local-only, like clientVariableLine's picklistvalues/linetype -- never touches
// the Master Runbook Service proxy or the shared ArmaninoCloudSync package.
export const runbookTagService = {
  get,
  create,
  update,
  remove,
  reorder,
};

function get(requestParameters) {
  let url = `/runbooktag?${Utils.objectToQueryString(requestParameters)}`;

  // #2660: only used to populate the Tag dropdown (RunbookForm, EditRunbookModal) and the grid's
  // group-by-tag view -- same class of bug as #2583 (runbookserver/getall). A 401 here means the
  // caller lacks access to this particular lookup, not that their session is dead, so it shouldn't
  // force a logout. See the skipAuthRedirect comment in api/http.js.
  return http.get(url, { skipAuthRedirect: true }).then((response) => {
    return response;
  });
}

function create(requestBody) {
  let url = `/runbooktag/create`;

  return http.post(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

function update(requestBody) {
  let url = `/runbooktag/update`;

  return http.put(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

function remove(requestParameters) {
  let url = `/runbooktag/delete?${Utils.objectToQueryString(requestParameters)}`;

  return http.delete(url).then((response) => {
    return response;
  });
}

function reorder(requestBody) {
  let url = `/runbooktag/reorder`;

  return http.put(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}
